<script setup lang="ts">
import { KsIcon } from '@aschehoug/kloss'
import type { RouteLocation } from 'vue-router'

const { buttonText } = defineProps<{
  buttonText: string
  to: RouteLocation
}>()

const decodedBtnText = computed(() => decodeURIComponent(buttonText))
</script>

<template>
  <router-link
    :aria-label="`Gå tilbake til ${decodedBtnText}`"
    :to="to"
  >
    <KsIcon id="chevron-left" />
    {{ decodedBtnText }}
  </router-link>
</template>

<style lang="scss" scoped>
  a {
    text-decoration: none;
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--color-blue-50);
    gap: 4px;
    padding: 0;
    width: fit-content;

    svg {
      width: 1rem !important;
      height: 1rem !important;
    }

    &:focus-visible {
      outline: 3px solid var(--ks-focusring);
    }
  }
</style>
